import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NbPopoverModule } from '@nebular/theme';
import { MealItemPresentationModule } from '../MealItemPresentation/meal-item-presentation.module';
import {
  MealItemsPresentationComponent,
  MobileMealItemsPresentationComponent,
  MealItemsPresentationReportComponent,
} from './meal-items-presentation.component';

const NB_MODULES = [NbPopoverModule];

@NgModule({
  imports: [
    CommonModule,
    MealItemPresentationModule,
    ...NB_MODULES,
    DragDropModule,
  ],
  declarations: [
    MealItemsPresentationComponent,
    MobileMealItemsPresentationComponent,
    MealItemsPresentationReportComponent,
  ],
  exports: [
    MealItemsPresentationComponent,
    MobileMealItemsPresentationComponent,
    MealItemsPresentationReportComponent,
  ],
})
export class MealItemsPresentationModule {}
